module.exports = __webpack_public_path__ + "static/media/project-management.d9d01af3.svg";